// removed by extract-text-webpack-plugin
module.exports = {"white":"#FFFFFF","bp":"(min-width: 700px)","testimonial":"src-components-Testimonial----Testimonial-module---testimonial---kPvJk","inner":"src-components-Testimonial----Testimonial-module---inner---HlTaR","photo":"src-components-Testimonial----Testimonial-module---photo---quwwb","body":"src-components-Testimonial----Testimonial-module---body---1pa8N","meta":"src-components-Testimonial----Testimonial-module---meta---1gCez"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Testimonial/Testimonial.module.css
// module id = 208
// module chunks = 35783957827783 114276838955818